<template>
  <div>
    <EditableArea
      v-if="mixinEnvironnement_inEditor"
      class="row no-gutters h-100"
      :content="content.row"
      :parentTemplateId="metadata['mgnl:template']"
    >
    </EditableArea>
    <b-container v-else class="conteneur-carrousel p-0">
      <div class="typeTitre">
        <div class="row">
          <div
            class="d-flex justify-content-start col-10"
            :class="{ 'position-texte mw-100': $isMobile() }"
            v-html="content.formatAffichage.titre"
          ></div>
          <div
            v-if="isDesktopOuTablette() && content.row[0].column['@nodes'] != null"
            class="col-2 d-flex justify-content-end"
          >
            <div class="prev mr-1" tabindex="0" @keydown="enterGauche($event)" @click="prev">
              <svg-icon
                class="iconeAvecBordure rotation90 cursor_pointer"
                icon-name="fleche-bas"
                stroke="currentColor"
                fill="$couleur-fond-primaire"
              ></svg-icon>
            </div>
            <div class="next" tabindex="0" @keydown="enterDroite($event)" @click="next">
              <svg-icon
                class="iconeAvecBordure rotation270 cursor_pointer"
                icon-name="fleche-bas"
                stroke="currentColor"
                fill="$couleur-fond-primaire"
              ></svg-icon>
            </div>
          </div>
        </div>
      </div>
      <div v-if="content.row[0].column['@nodes'] == null">
        <Titre
          :content="{
            type: 'typeSousTitre',
            titre: $t('messageComponent.carrouselVide'),
          }"
        ></Titre>
      </div>
      <b-carousel
        v-else
        :id="carrouselId"
        ref="mediaImageCarrousel"
        :interval="parseInt(content.row.carrouselTimer)"
        :controls="false"
        no-animation
        :class="content.formatAffichage.carrouselSize == 'FullScreen' ? 'takeFullWidth' : null"
        @sliding-start="onSlideStart"
      >
        <div
          v-for="(aNode, index) in content.row[0].column['@nodes']"
          :key="aNode.id"
          ref="carrouselItem"
          class="carousel-item"
          @keydown="clavierImages($event)"
          @click="appuyerImages(index)"
        >
          <div class="row align-items-center flex-nowrap takeFullWidth">
            <template v-for="(aNode, idx) in content.row[0].column['@nodes']">
              <component
                :is="
                  content.row[0].column[
                    content.row[0].column['@nodes'][
                      (index + idx) % content.row[0].column['@nodes'].length
                    ]
                  ].format
                "
                v-if="content.row[0].column[aNode].format"
                :ref="idx == getIndexOfMiddleImg ? 'imgToCenter' : 'imgWithoutText'"
                :key="
                  content.row[0].column[
                    content.row[0].column['@nodes'][
                      (index + idx) % content.row[0].column['@nodes'].length
                    ]
                  ]['@id']
                "
                tabindex="0"
                class="container"
                :class="idx == getIndexOfMiddleImg ? 'pb-0' : 'pt-0 mt-n1'"
                :style="
                  idx == getIndexOfMiddleImg
                    ? '!important; margin-right: calc(0.45 * -2rem); margin-left: calc(0.45 * -2rem);'
                    : 'padding-right: calc(1.45 * 2rem) !important; padding-left: calc(1.45 *   2rem) !important; margin-right: calc(1.25 * -2rem); margin-left: calc(1.25 * -2rem);'
                "
                :content="
                  content.row[0].column[
                    content.row[0].column['@nodes'][
                      (index + idx + longueurReajustee) % content.row[0].column['@nodes'].length
                    ]
                  ]
                "
              >
              </component>
            </template>
          </div>
        </div>
      </b-carousel>
    </b-container>
  </div>
</template>
<script>
import Column from '@/components/container/grid/Column';
import { EditableArea } from '@/vue-editor';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import mediaImageSimple from '@/components/media/image/MediaImageSimple';
import mediaImageImg90TitSouTit from '@/components/media/image/MediaImageImg90TitSouTit';
import Titre from '@/components/base/Titre';

export default {
  name: 'Carrousel',
  components: {
    EditableArea,
    Column,
    Titre,
    mediaImageSimple,
    mediaImageImg90TitSouTit,
  },
  mixins: [mixinEnvironnement],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      translateWidth: null,
      slide: 0,
      carrouselItemLength: 0,
    };
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          carrouselVide: 'Aucune information disponible',
        },
      },
      en: {
        messageComponent: {
          carrouselVide: 'No available information',
        },
      },
    },
  },
  computed: {
    CS_TOUCHE_FLECHE_GAUCHE: () => 37,
    CS_TOUCHE_FLECHE_DROITE: () => 39,
    CS_TOUCHE_ENTER: () => 13,
    getIndexOfMiddleImg() {
      if (this.carrouselItemLength == 2) {
        return 0;
      }
      if (this.carrouselItemLength == 3 || this.carrouselItemLength == 4) {
        return 1;
      }
      return 2;
    },
    carrouselId() {
      return this.uid;
    },
    longueurReajustee() {
      return this.carrouselItemLength - 2 > 0 ? this.carrouselItemLength - 2 : 0;
    },
  },
  mounted() {
    // Obtient le nombre de slides total
    this.carrouselItemLength = this.$refs.carrouselItem.length;
    // Centrer le carrousel
    this.setTranslation();
    // Cacher le texte sous les medias non centrés
    this.hideTexteSousImage();
    window.onresize = () => {
      this.resetAllTranslation();
      this.setTranslation();
    };
  },
  methods: {
    isDesktopOuTablette() {
      return !this.$isMobile() || (this.$isMobile() && window.innerWidth >= 768);
    },
    onSlideStart(slide) {
      this.slide = slide;
    },
    prev() {
      this.slide =
        (((this.slide - 1) % this.carrouselItemLength) + this.carrouselItemLength) %
        this.carrouselItemLength;
      this.$refs.mediaImageCarrousel.prev();
    },
    next() {
      this.slide =
        (((this.slide + 1) % this.carrouselItemLength) + this.carrouselItemLength) %
        this.carrouselItemLength;
      this.$refs.mediaImageCarrousel.next();
    },
    resetAllTranslation() {
      for (let i = 0; i < this.carrouselItemLength; i++) {
        this.$refs.carrouselItem[i].style.marginLeft = '0px';
      }
    },
    setTranslation() {
      this.translateWidth =
        this.$refs.imgToCenter[this.slide].$el.getBoundingClientRect().x +
        this.$refs.imgToCenter[this.slide].$el.offsetWidth / 2 -
        document.body.clientWidth / 2;

      for (let i = 0; i < this.$refs.carrouselItem.length; i++) {
        this.$refs.carrouselItem[i].style.marginLeft = `calc(-1 * ${this.translateWidth}px)`;
      }
    },
    hideTexteSousImage() {
      for (let slides = 0; slides < this.$refs.imgWithoutText.length; slides++) {
        if (this.$refs.imgWithoutText[slides].$refs.texteSousImage != null) {
          this.$refs.imgWithoutText[slides].$refs.texteSousImage.classList.add('d-none');
        }
      }
    },
    enterGauche(event) {
      if (event.keyCode == this.CS_TOUCHE_ENTER) {
        this.prev();
      }
    },
    enterDroite(event) {
      if (event.keyCode == this.CS_TOUCHE_ENTER) {
        this.next();
      }
    },
    clavierImages(event) {
      if (event.keyCode == this.CS_TOUCHE_ENTER) {
        this.prev();
      }
      if (event.keyCode == this.CS_TOUCHE_FLECHE_GAUCHE) {
        this.prev();
      }
      if (event.keyCode == this.CS_TOUCHE_FLECHE_DROITE) {
        this.next();
      }
    },
    appuyerImages(nodeId) {},
  },
};
</script>
<style lang="scss" scoped>
.takeFullWidth {
  width: 97vw !important;
  margin-left: calc(-48.5vw + 50%) !important;
}
.iconeAvecBordure {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  border: 1px solid $couleur-bordure-icone-carousel;
  border-radius: 50%;
}
.cursor_pointer {
  cursor: pointer;
}
.position-texte {
  @include media-breakpoint-down(xs) {
    flex: 0 0 100%;
  }
}
</style>
